import script from "./ServiceCardSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceCardSlider.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceCardSlider.vue?vue&type=style&index=0&id=5ce908bb&lang=css"

const __exports__ = script;

export default __exports__